import React from "react";

import { FormattedMessage } from "react-intl";

import { Button } from "../../../button";
import { Image } from "../../../image";
import { useSendCommand } from "../../../../hooks/use-send-command";
import { useOpenNewsArticle } from "../../../../hooks/use-open-news-article";
import { usePollContext } from "../../../../stores/poll";

import { parseCTAs } from "../parse-ctas";
import { handleCTAClick } from "..";

// import { AzurePhoenixTimer } from "./timer";
import { withCountdown } from "../../../../hocs/with-countdown";

import azurePhoenixImageWebP from "./azure-phoenix.webp";
import azurePhoenixImagePng from "./azure-phoenix.png";

import styles from "./styles.modules.scss";

export type AzurePhoenixSlideType = {
    type: "eventEntry" | null;
    id: string;
    background?: ImageSourceSets;
    ctas: InboxCTA[];
    displayTimer: boolean;
    isNew?: boolean;
    timerKind?: InboxEventTimerKind;
    timerLabel: string;
    timerTarget: number;
    title: string;
    countdown: number;
    hideTitle: boolean;
    limit?: number;
    targeting?: Targeting;
    relatedMedia?: RelatedMedia[];
};

const AzurePhoenixSlideView = ({
    slide,
    countdown,
}: {
    slide: AzurePhoenixSlideType;
    countdown: number | undefined;
}) => {
    const {
        background,
        ctas,
        displayTimer,
        hideTitle,
        timerLabel,
        title,
        timerKind,
    } = slide;

    const sendCommand = useSendCommand();
    const openNewsArticle = useOpenNewsArticle();
    const {
        actions: { openModal },
    } = usePollContext();

    const handleClick = handleCTAClick(
        sendCommand,
        openNewsArticle,
        openModal,
        title,
    );

    const parsedCTAs = (() => {
        if (!timerKind) {
            return parseCTAs(ctas, handleClick);
        }

        if (timerKind === "SHOW_CTA") {
            return countdown && countdown > 0
                ? []
                : parseCTAs(ctas, handleClick);
        }

        if (timerKind === "HIDE_CTA") {
            return countdown && countdown > 0
                ? parseCTAs(ctas, handleClick)
                : [];
        }

        return parseCTAs(ctas, handleClick);
    })();

    const displayTimerFormatted = Boolean(
        displayTimer && countdown !== undefined,
    );

    return (
        <div className={`slide azure-phoenix ${styles.slide}`}>
            <div
                className={`content ${styles.content} ${
                    displayTimerFormatted ? "with-timer" : ""
                }`}
            >
                {background && (
                    <div className={`image ${styles.image}`}>
                        <Image sources={background} cover />
                    </div>
                )}

                {!hideTitle && (
                    <>
                        <div className={`filter ${styles.filter}`} />

                        <div className={`title-image ${styles.titleImage}`}>
                            <picture>
                                <source
                                    srcSet={azurePhoenixImageWebP}
                                    type="image/webp"
                                />
                                <img src={azurePhoenixImagePng} alt={title} />
                            </picture>
                        </div>
                    </>
                )}

                {/* {displayTimerFormatted && countdown !== undefined && (
                    <div
                        className={`countdown-center ${styles.countdownCenter}`}
                    >
                        <AzurePhoenixTimer
                            countdown={countdown}
                            timerLabel={undefined}
                        />
                    </div>
                )} */}

                <div className={`wrapper ${styles.wrapper}`}>
                    {displayTimerFormatted &&
                        countdown !== undefined &&
                        countdown > 0 &&
                        timerLabel && (
                            <div className={`timer-label ${styles.timerLabel}`}>
                                {timerLabel}
                            </div>
                        )}

                    {parsedCTAs.length ? (
                        <div
                            className={`ctas ${
                                parsedCTAs.length === 1 ? "single" : "multi"
                            } ${styles.ctas}`}
                        >
                            {parsedCTAs.map(
                                ({ label, onClick, variant }, index) => (
                                    <Button
                                        key={index}
                                        onClick={onClick}
                                        variant={variant}
                                    >
                                        <span className="buttonTextWrapper">
                                            {label || (
                                                <FormattedMessage id="globalText.langGo" />
                                            )}
                                        </span>
                                    </Button>
                                ),
                            )}
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

const mapTimerProperty = ({ timerTarget }: { timerTarget: number }) =>
    timerTarget;

export const withMappedTimerProperty = withCountdown(mapTimerProperty);

export const AzurePhoenixSlide = withMappedTimerProperty(AzurePhoenixSlideView);
